import React, { createContext, useState, useEffect, useContext } from 'react';

const VoiceContext = createContext();

export function VoiceProvider({ children }) {
  const [voices, setVoices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const synth = window.speechSynthesis;
    let voicesLoaded = false;

    const loadVoices = () => {
      const availableVoices = synth.getVoices();
      if (availableVoices.length > 0) {
        setVoices(availableVoices);
        setLoading(false);
        voicesLoaded = true;
        // "Wake up" the speech engine on some browsers.
        const utterance = new SpeechSynthesisUtterance('');
        utterance.volume = 0;
        synth.speak(utterance);
        console.log('Speech synthesis voices loaded.');
        // No need to listen for changes anymore if we have them.
        if (synth.onvoiceschanged !== undefined) {
            synth.onvoiceschanged = null;
        }
      }
    };

    // Attempt to load voices immediately.
    loadVoices();

    // If voices are not loaded yet, set up a listener.
    if (synth.onvoiceschanged !== undefined) {
      synth.onvoiceschanged = loadVoices;
    }

    // Fallback with an interval check.
    const intervalId = setInterval(() => {
      if (!voicesLoaded) {
        loadVoices();
      } else {
        clearInterval(intervalId);
      }
    }, 500);

    return () => {
      clearInterval(intervalId);
      if (synth.onvoiceschanged !== undefined) {
        synth.onvoiceschanged = null;
      }
    };
  }, []);

  const value = { voices, loading };

  return (
    <VoiceContext.Provider value={value}>
      {children}
    </VoiceContext.Provider>
  );
}

export function useVoice() {
  return useContext(VoiceContext);
}
